export default "__VITE_ASSET__6lKX4KTE__"